import React from "react";

import { Link, makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core/styles";

import {
  benefitsBannerContent,
  benefitsBannerImage,
} from "../../content/benefitsBannerContent";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "block",
    width: "100%",
    maxWidth: 1700,
    margin: "0 auto",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: 10,
    overflow: "hidden",
    textDecoration: "none",
    cursor: "pointer",
    boxShadow: "0rem 0.25rem 0.90rem 0rem rgba(176, 193, 225, 0.25)",
    transition: "box-shadow 0.2s ease, transform 0.2s ease",
    "&:hover": {
      boxShadow: "0rem 0.375rem 1.25rem 0rem rgba(176, 193, 225, 0.45)",
      transform: "translateY(-2px)",
    },
  },
  image: {
    display: "block",
    width: "100%",
    // Altura livre: a arte (proporção 3:1) define a própria altura e escala
    // proporcionalmente com a largura, sem recorte.
    height: "auto",
    userSelect: "none",
    WebkitUserDrag: "none",
  },
}));

/**
 * Faixa full-width da campanha de benefícios, exibida no topo da Home do
 * revendedor. A arte (imagem 3:1 do marketing) já contém toda a copy e a
 * chamada; o banner é apenas a imagem clicável, que abre o site de marketing
 * em uma nova aba.
 */
const BenefitsBannerStrip: React.FC = () => {
  const classes = useStyles();
  const { altText, ctaHref } = benefitsBannerContent;

  return (
    <Link
      className={classes.root}
      href={ctaHref}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={altText}
    >
      <img
        className={classes.image}
        src={benefitsBannerImage}
        alt={altText}
        draggable={false}
      />
    </Link>
  );
};

export default BenefitsBannerStrip;
